import { useTranslation } from "react-i18next";
import BottomModal from "./BottomModal";

interface OauthLoginModalProps {
  isVisible: boolean;
  roomName: string;
}

export default function OauthLoginModal({
  isVisible,
  roomName,
}: OauthLoginModalProps) {
  const { t } = useTranslation();

  return (
    <BottomModal
      visible={isVisible}
      modalStyle={{
        padding: "32px 20px",
        gap: 16,
        alignItems: "center",
      }}
    >
      <div className="flex justify-center items-center">
        <div className="w-[60px] h-[60px] border-[3px] border-[#e0e0e0] border-t-primary-black rounded-full animate-spin" />
      </div>

      <span className="text-center text-2xl font-bold text-primary-black leading-[1.2]">
        {t("Checking your {{roomName}} account...", { roomName })}
      </span>

      <span className="text-center text-sm font-normal text-[#929292] leading-[1.4]">
        {t("This may take a few seconds...")}
      </span>
    </BottomModal>
  );
}
